import { Link } from 'react-router-dom';
import './not-found-in-page.css';

/**
 * The in-page empty state for a detail route whose id doesn't exist (D202,
 * H7 §2). It replaces the detail inside the page the route belongs to — never
 * the app's 404 and never another page. Same copy everywhere:
 *   title  "We can't find {thing} {id}"
 *   text   "It may have been closed, merged or undone."
 *   link   "See all {things}"
 */
export function NotFoundInPage({
  thing,
  id,
  listLabel,
  listTo,
  as: Tag = 'div',
}: {
  /** The noun, lower case, with its article-free form: "appeal", "claim", "pre-auth"… */
  thing: string;
  /** The id from the URL. Omit for the payer page's "this payer" wording. */
  id?: string;
  /** "See all appeals sent" → pass "appeals sent". */
  listLabel: string;
  listTo: string;
  as?: 'div' | 'main';
}) {
  const title = id ? `We can’t find ${thing} ${id}` : `We can’t find this ${thing}`;
  return (
    <Tag className="nfp" role="status">
      <h2 className="nfp-title">{title}</h2>
      <p className="nfp-text">It may have been closed, merged or undone.</p>
      <Link to={listTo} className="nfp-link">
        See all {listLabel}
      </Link>
    </Tag>
  );
}
